import { apiClient } from 'services/api-client';
import { PaginatedResponse, toPaginatedResponse } from 'dtos/common/api.dto';
import { apiConfig } from 'config/app.config';
import { getCurrentAccessToken } from 'services/auth/supabase.client';

export class ReportService {
  static async get(orgId: string, storeId: string, reportType: string, page = 1, pageSize = 8): Promise<PaginatedResponse<Record<string, any>>> {
    const response = await apiClient.get<Record<string, any>[]>(`/orgs/${orgId}/stores/${storeId}/reports/${reportType}?page=${page}&pageSize=${pageSize}`);
    return toPaginatedResponse(response, page, pageSize);
  }

  static async download(orgId: string, storeId: string, reportType: string): Promise<void> {
    const token = await getCurrentAccessToken();
    const response = await fetch(`${apiConfig.baseUrl}/reports/orgs/${orgId}/stores/${storeId}/reports/${reportType}?format=csv`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
    if (!response.ok) throw new Error('Unable to download report');
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${reportType}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  }
}
